export * from './PIKBanner';
export * from './ParallaxBanner';

export enum EAdFoxBannerType {
  PIK = 'more_parameters',
  PARALLAX = 'parallax',
}

export interface IBanners {
  [key: string]: {
    [key: string]: string;
  };
}

const banners: IBanners = {
  [EAdFoxBannerType.PIK]: {
    p1: 'bwgxy',
    p2: 'fmsa',
  },
  [EAdFoxBannerType.PARALLAX]: {
    p1: 'bvkoa',
    p2: 'y',
    pct: 'a',
    pfb: 'a',
    pfc: 'a',
    plp: 'a',
    pli: 'a',
    pop: 'a',
    pt: 'b',
    random: '1768139593',
  },
};

export function getBannerByType(type: EAdFoxBannerType) {
  return banners[type];
}
